/**
 * Local Delivery Cart checkout helpers.
 * Extracted from local-delivery-cart orchestrator.
 */
(function () {
  'use strict';

  function isoToDmy(iso) {
    if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso || '';
    var p = iso.split('-');
    return p[2] + '/' + p[1] + '/' + p[0];
  }

  function buildNativeCheckoutUrl(prefill) {
    prefill = prefill || {};
    var params = [];

    if (prefill.sEmail) params.push('checkout[email]=' + encodeURIComponent(prefill.sEmail));

    if (prefill.rFirst) params.push('checkout[shipping_address][first_name]=' + encodeURIComponent(prefill.rFirst));
    if (prefill.rLast) params.push('checkout[shipping_address][last_name]=' + encodeURIComponent(prefill.rLast));
    if (prefill.rPhone) params.push('checkout[shipping_address][phone]=' + encodeURIComponent(prefill.rPhone));
    if (prefill.rAddr1) params.push('checkout[shipping_address][address1]=' + encodeURIComponent(prefill.rAddr1));
    if (prefill.rAddr2) params.push('checkout[shipping_address][address2]=' + encodeURIComponent(prefill.rAddr2));
    if (prefill.rPostal) params.push('checkout[shipping_address][zip]=' + encodeURIComponent(prefill.rPostal));

    params.push('checkout[shipping_address][city]=' + encodeURIComponent('Singapore'));
    params.push('checkout[shipping_address][country]=' + encodeURIComponent('SG'));

    var shopDomain = window.Shopify && window.Shopify.shop ? window.Shopify.shop : '';
    var base = shopDomain ? 'https://' + shopDomain + '/checkout' : '/checkout';
    return base + (params.length > 0 ? '?' + params.join('&') : '');
  }

  function fallbackToNativeCheckout(prefill) {
    var fallbackUrl = buildNativeCheckoutUrl(prefill || {});
    console.warn('[wf-ld] Falling back to native checkout', fallbackUrl);
    return fallbackUrl;
  }

  function buildCartAttributes(input) {
    input = input || {};
    var deliveryMethod = input.deliveryMethod || 'Delivery';
    var deliveryDate = input.deliveryDate || '';
    var deliveryTimeslot = input.deliveryTimeslot || '';
    var slotId = input.slotId || '';
    var timeVal = input.timeVal || '';
    var recipient = input.recipient || {};
    var sender = input.sender || {};
    var anonChecked = !!input.anonChecked;

    return {
      'Delivery Method': deliveryMethod,
      delivery_date: deliveryMethod === 'Collection' ? '' : deliveryDate,
      delivery_timeslot: deliveryMethod === 'Collection' ? '' : deliveryTimeslot,
      delivery_slot_id: slotId,
      'Local Delivery Date and Time': timeVal,
      'Collection Date and Time': deliveryMethod === 'Collection' ? timeVal : '',
      'Delivery Area': deliveryMethod === 'Collection' ? '' : (recipient.postal || ''),
      recipient_first_name: recipient.firstName || '',
      recipient_last_name: recipient.lastName || '',
      recipient_phone: recipient.phone || '',
      recipient_address1: recipient.address1 || '',
      recipient_address2: recipient.address2 || '',
      recipient_postal: recipient.postal || '',
      collection_date: deliveryMethod === 'Collection' ? deliveryDate : '',
      collection_timeslot: deliveryMethod === 'Collection' ? deliveryTimeslot : '',
      sender_first_name: sender.firstName || '',
      sender_last_name: sender.lastName || '',
      sender_email: sender.email || '',
      sender_phone: sender.phone || '',
      sender_anonymous: anonChecked ? 'Yes' : '',
    };
  }

  function buildStorefrontCheckoutPayload(input) {
    input = input || {};
    var recipient = input.recipient || {};
    var sender = input.sender || {};

    var payload = {
      lineItems: input.lineItems || [],
      deliveryMethod: input.deliveryMethod || '',
      deliveryDate: input.deliveryDate || '',
      deliveryDateIso: input.deliveryDateIso || '',
      deliveryTimeslot: input.deliveryTimeslot || '',
      deliverySlotId: input.deliverySlotId || '',
      recipientFirstName: recipient.firstName || '',
      recipientLastName: recipient.lastName || '',
      recipientPhone: recipient.phone || '',
      recipientAddress1: recipient.address1 || '',
      recipientAddress2: recipient.address2 || '',
      recipientPostal: recipient.postal || '',
      senderFirstName: sender.firstName || '',
      senderLastName: sender.lastName || '',
      senderEmail: sender.email || '',
      senderPhone: sender.phone || '',
      note: input.note || '',
    };
    if (Array.isArray(input.customAttributes) && input.customAttributes.length > 0) {
      payload.customAttributes = input.customAttributes;
    }
    return payload;
  }

  window.WF_LD_CART_CHECKOUT = {
    isoToDmy: isoToDmy,
    buildNativeCheckoutUrl: buildNativeCheckoutUrl,
    fallbackToNativeCheckout: fallbackToNativeCheckout,
    buildCartAttributes: buildCartAttributes,
    buildStorefrontCheckoutPayload: buildStorefrontCheckoutPayload,
  };
})();
